import React from "react";
import {
  FaLayerGroup,
  FaShieldAlt,
  FaCoins,
  FaNetworkWired,
  FaLaptopCode,
} from "react-icons/fa";

// Reusable process step
function ProcessStep({ Icon, title, description }) {
  return (
    <div className="col-lg-4 col-md-6">
      <div className="process-style-two-item">
        <div className="icon pb-30">
          <Icon size={40} />
        </div>
        <h4>{title}</h4>
        <p className="pb-10">{description}</p>
      </div>
    </div>
  );
}

function OptimisticRollup() {
  const steps = [
    {
      title: "Custom Layer-2 Solutions",
      description:
        "We build custom layer-2 applications using OP Stack to enhance scalability, reduce costs, and ensure high transaction throughput.",
      Icon: FaLayerGroup,
    },
    {
      title: "Smart Contract Development & Audit",
      description:
        "Xeer’s team creates secure, reliable smart contracts tailored to your specific needs, rigorously tested for performance and security.",
      Icon: FaShieldAlt,
    },
    {
      title: "Optimistic Rollup Implementation",
      description:
        "With OP Stack, we deploy optimistic rollups to minimize gas fees and support high transaction volume, improving user experience and network efficiency.",
      Icon: FaCoins,
    },
    {
      title: "Cross-Chain Integrations",
      description:
        "Our cross-chain solutions enable secure data and asset transfers across blockchains, maximizing your project’s reach and interoperability.",
      Icon: FaNetworkWired,
    },
    {
      title: "NFT Platform Development",
      description:
        "Develop NFT marketplaces optimized with OP Stack, offering users fast, cost-effective trading solutions with Ethereum compatibility.",
      Icon: FaLaptopCode,
    },
    {
      title: "DeFi Platform Development",
      description:
        "We design scalable DeFi applications with staking, lending, and yield farming, providing a seamless, low-cost user experience on Ethereum-compatible layer-2 networks.",
      Icon: FaLayerGroup,
    },
  ];

  return (
    <div
      className="process-style-two-area overflow-hidden bg-cover default-padding bg-dark text-light"
      style={{
        backgroundImage:
          "url(https://validthemes.net/site-template/robok/assets/img/shape/banner-20.jpg)",
      }}
    >
      <div className="container">
        <div className="site-heading">
          <div className="row align-center">
            <div className="col-lg-6">
              <h4 className="sub-title">Our Process</h4>
              <h2 className="title split-text-right split-text-in-right split-lines">
                Our OP Stack Development Services
              </h2>
            </div>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="process-style-two-items">
          <div className="row">
            {steps.map((step, idx) => (
              <ProcessStep key={idx} {...step} />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default OptimisticRollup;
